import {
    ODataHeader,
    ODataString,
    ODataBoolean
} from "pbas-vue-components";
import { translate } from '../trans'
import store from '@/store'
import { translate2 } from "../trans2";

const PagesHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "PlanId",
        type: new ODataString("PlanId"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.active",
        type: new ODataBoolean("Active"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/Id"),
        visible: false,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/LanguageCode"),
        visible: false,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/Html"),
        visible: false,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.title",
        type: new ODataString("Translations[]/Title", {
            getString: (item) => translate2(item, "Title"),
          }),
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        sortable: false,
        version: 1
    }),
    new ODataHeader({
        title: "headers.brokers.route",
        type: new ODataString("Route", {
            getString: (item, type) => {
              return item.Route==="pages.guest"?"Guest":"Authorized User"
            },
          }),
        visible: true,
        allowVisibilityChange: true,
        version: 1
    }),
    new ODataHeader({
        type: new ODataBoolean("Footer"),
        visible: false,
        allowVisibilityChange: false
    })
];
export default PagesHeaders;